import axiosApiClient from "../axios";

const PATH = '/api/company-admin';

export const getAllCompanyAdmins = async () => {
    try {
        return await axiosApiClient.get(PATH);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all company admins');
    }
};

export const getCompanyAdminById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get company admin by ID');
    }
};

export const getCompanyAdminByUsername = async (username) => {
    try {
        return await axiosApiClient.get(`${PATH}/username/${username}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get company admin by username');
    }
};

export const createCompanyAdmin = async (formData) => {
    try {
        return await axiosApiClient.post(PATH, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to create company admin');
    }
};

export const updateCompanyAdmin = async (id, formData) => {
    try {
        return await axiosApiClient.put(`${PATH}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to update company admin');
    }
};

export const deleteCompanyAdmin = async (id) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to delete company admin');
    }
};

